import Vue from 'vue'

export const Get = (url, options) => {
  return Vue.http.get(url, options)
}

export const Post = (url, payload) => {
  return Vue.http.post(url, payload)
}

export const Put = (url, payload) => {
  return Vue.http.put(url, payload)
}

export const Patch = (url, payload) => {
  return Vue.http.patch(url, payload)
}

export const Delete = (url, id) => {
  return Vue.http.delete(url + id)
}
export const Jsonp = (url, accessorigin) => {
  let headers = {
    'access-control-allow-credentials': 'true',
    'access-control-allow-origin': accessorigin
  }
  return Vue.http.jsonp(url, headers)
      .then(response => response.data)
      .catch(err => {
        console.log('get err', err)
      })
}
export const PostWithAuth = (url, payload, token) => {
  if (typeof token !== 'undefined' && token != null) {
    let options =
      {
        headers: { 'Authorization': 'Bearer ' + token }
      }
    return Vue.http.post(url, payload, options)
  }
}
export const PutWithAuth = (url, payload, token) => {
  if (typeof token !== 'undefined' && token != null) {
    let options =
      {
        headers: { 'Authorization': 'Bearer ' + token }
      }
    return Vue.http.put(url, payload, options)
  }
}
export const PatchWithAuth = (url, payload, token) => {
  if (typeof token !== 'undefined' && token != null) {
    let options =
      {
        headers: { 'Authorization': 'Bearer ' + token }
      }
    return Vue.http.patch(url, payload, options)
  }
}
export const DeleteWithAuth = (url, id, token) => {
  if (typeof token !== 'undefined' && token != null) {
    let options =
      {
        headers: { 'Authorization': 'Bearer ' + token }
      }
    return Vue.http.delete(url + id, options)
  }
}
export const GetWithAuth = (url, token) => {
  if (typeof token !== 'undefined' && token != null) {
    let options =
      {
        headers: { 'Authorization': 'Bearer ' + token }
      }
    return Vue.http.get(url, options)
  }
}



// WEBPACK FOOTER //
// ./src/modules/requester/index.js